import { type ReactNode } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { LoadingSpinner } from '../common/LoadingSpinner'

interface RequireKlantProps {
  children: ReactNode
}

/**
 * Klant-hub layout: iedereen met een sessie mag eigen afspraken/profiel bekijken,
 * ook salon-eigenaren en team (zelfde account als klant).
 * Niet-ingelogde gebruikers zien op de betreffende pagina's het klant-inlogformulier.
 */
export function RequireKlant({ children }: RequireKlantProps) {
  const { loading, profileLoading } = useAuth()

  if (loading || profileLoading) return <LoadingSpinner />

  return <>{children}</>
}
